import { Verified } from 'lucide-react'
import { MobileDealsPage } from 'pages/app/deals/mobile'
import { MobileContactsPage } from 'pages/app/contacts/mobile'
import Home from 'pages/app/mobile/home'
import SearchPage from 'pages/app/mobile/search'
import { MobileAppLayout } from 'pages/app/mobile/layout'
import MobileNotFound from 'pages/app/mobile/mobile-not-found'
import Failed from 'pages/auth/failed'
import { MobileAuthLayout } from 'pages/auth/layout/mobile'
import Login from 'pages/auth/login'
import Register from 'pages/auth/register'
import ResetPassword from 'pages/auth/reset-password'
import ResetPasswordConfirm from 'pages/auth/reset-password-confirm'
import SSOCallback from 'pages/auth/sso-callback'
import SSOLogin from 'pages/auth/sso-login'
import { MobileCommonLayout } from 'pages/common/layout/mobile'
import Privacy from 'pages/common/privacy'
import Terms from 'pages/common/terms'
import Oops from 'pages/oops'
import { RouterProvider } from 'react-router-dom'
import { sentryCreateBrowserRouter } from 'services/sentry'
import { PageWithTitle } from 'utils/PageWithTitle'
import ProtectedRoute from 'utils/ProtectedRoute'
import { MobileDealsCreate } from 'pages/app/deals/MobileDealsCreate'
import MobileContactsCreate from 'pages/app/contacts/mobile/MobileContactsCreate'

export default function Mobile() {
  const appRouter = sentryCreateBrowserRouter([
    {
      path: '*',
      element: (
        <ProtectedRoute>
          <MobileNotFound />
        </ProtectedRoute>
      ),
    },
    {
      path: '/',
      element: <MobileAppLayout />,
      errorElement: <Oops />,
      children: [
        {
          path: '',
          element: (
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          ),
        },
        {
          path: 'deals',
          element: (
            <ProtectedRoute>
              <PageWithTitle title="Deals">
                <MobileDealsPage />
              </PageWithTitle>
            </ProtectedRoute>
          ),
        },
        {
          path: 'deals/create',
          element: (
            <ProtectedRoute>
              <PageWithTitle title="Deals">
                <MobileDealsCreate />
              </PageWithTitle>
            </ProtectedRoute>
          ),
        },
        {
          path: 'contacts',
          element: (
            <ProtectedRoute>
              <PageWithTitle title="Contacts">
                <MobileContactsPage />
              </PageWithTitle>
            </ProtectedRoute>
          ),
        },
        {
          path: 'contacts/create',
          element: (
            <ProtectedRoute>
              <PageWithTitle title="Contacts">
                <MobileContactsCreate />
              </PageWithTitle>
            </ProtectedRoute>
          ),
        },
        {
          path: 'search',
          element: (
            <ProtectedRoute>
              <PageWithTitle title="Search">
                <SearchPage />
              </PageWithTitle>
            </ProtectedRoute>
          ),
        },
      ],
    },
    {
      path: '/login',
      element: <MobileAuthLayout />,
      children: [
        {
          path: '',
          element: (
            <PageWithTitle title="Log-in">
              <Login />
            </PageWithTitle>
          ),
        },
      ],
    },
    {
      path: '/signup',
      element: <MobileAuthLayout />,
      children: [
        {
          path: '',
          element: (
            <PageWithTitle title="Sign-up">
              <Register />
            </PageWithTitle>
          ),
        },
      ],
    },

    {
      path: '/sso-login',
      element: <MobileAuthLayout />,
      children: [
        {
          path: '',
          element: (
            <PageWithTitle title="SSO Login">
              <SSOLogin />
            </PageWithTitle>
          ),
        },
      ],
    },
    {
      path: '/auth/sso-callback',
      element: (
        <PageWithTitle title="SSO Authentication">
          <SSOCallback />
        </PageWithTitle>
      ),
    },
    {
      path: '/email-verified-confirmation',
      element: <MobileAuthLayout />,
      children: [
        {
          path: '',
          element: (
            <PageWithTitle title="Email Verified">
              <Verified />
            </PageWithTitle>
          ),
        },
      ],
    },
    {
      path: '/email-verification-failed',
      element: <MobileAuthLayout />,
      children: [
        {
          path: '',
          element: (
            <PageWithTitle title="Email Verification Failed">
              <Failed />
            </PageWithTitle>
          ),
        },
      ],
    },
    {
      path: '/reset-password',
      element: <MobileAuthLayout />,
      children: [
        {
          path: '',
          element: (
            <PageWithTitle title="Reset Password">
              <ResetPassword />
            </PageWithTitle>
          ),
        },
      ],
    },
    {
      path: '/password-reset-confirm/:uid/:token',
      element: <MobileAuthLayout />,
      children: [
        {
          path: '',
          element: (
            <PageWithTitle title="Reset Password Confirmation">
              <ResetPasswordConfirm />
            </PageWithTitle>
          ),
        },
      ],
    },
    {
      path: '/terms-of-use',
      element: <MobileCommonLayout />,
      children: [
        {
          path: '',
          element: (
            <PageWithTitle title="Terms of Use">
              <Terms />
            </PageWithTitle>
          ),
        },
      ],
    },
    {
      path: '/privacy-policy',
      element: <MobileCommonLayout />,
      children: [
        {
          path: '',
          element: (
            <PageWithTitle title="Privacy Policy">
              <Privacy />
            </PageWithTitle>
          ),
        },
      ],
    },
  ])

  return <RouterProvider router={appRouter} />
}
